// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const TooltipIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <path
                fill="currentColor"
                d="M7,0 C3.13359392,0 0,3.13359392 0,7 C0,10.8664061 3.13359392,14 7,14 C10.8664061,14 14,10.8664061 14,7 C14,3.13359392 10.8664061,0 7,0 Z M7,10.9375 C6.5078125,10.9375 6.125,10.5546875 6.125,10.0625 C6.125,9.5703125 6.48320329,9.1875 7,9.1875 C7.46757829,9.1875 7.875,9.5703125 7.875,10.0625 C7.875,10.5546875 7.46757829,10.9375 7,10.9375 Z M8.88945329,7.0546875 L7.65625,7.8203125 L7.65625,7.875 C7.65625,8.23046875 7.35546875,8.53125 7,8.53125 C6.64453125,8.53125 6.34375,8.23046875 6.34375,7.875 L6.34375,7.4375 C6.34375,7.21875 6.453125,7 6.671875,6.86328125 L8.23046875,5.93359375 C8.421875,5.82421875 8.53125,5.6328125 8.53125,5.4140625 C8.53125,5.0859375 8.23320329,4.8125 7.90507829,4.8125 L6.5078125,4.8125 C6.15507829,4.8125 5.90625,5.0859375 5.90625,5.4140625 C5.90625,5.76953125 5.60546875,6.0703125 5.25,6.0703125 C4.89453125,6.0703125 4.59375,5.76953125 4.59375,5.4140625 C4.59375,4.34765625 5.44140625,3.5 6.48320329,3.5 L7.88046908,3.5 C8.99609375,3.5 9.84375,4.34765625 9.84375,5.4140625 C9.84375,6.0703125 9.48828125,6.69921875 8.88945329,7.0546875 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default React.memo(TooltipIcon);
